import { ETAPAS_CADASTRO, etapaJaPassada, type EtapaCadastro } from '../../clientes/etapasCadastro'

const CAMINHOS: Record<EtapaCadastro, string> = {
  dados: 'M7 3h7l5 5v13H7zM14 3v5h5M10 13h6M10 17h6',
  endereco: 'M12 21s-6-5.6-6-10a6 6 0 1 1 12 0c0 4.4-6 10-6 10zM12 8.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z',
  comercial: 'M3 12V4h8l10 10-8 8zM7.5 8.5h.01',
  historico: 'M5 20V10M12 20V4M19 20v-7',
}

function Icone({ etapa }: { etapa: EtapaCadastro }) {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={CAMINHOS[etapa]} />
    </svg>
  )
}

// Quatro bolinhas ligadas por uma linha, como no print dela. Sao botoes: dá
// para pular de uma etapa para outra sem passar pelo "Próximo".
export default function PassosDoCadastro({
  atual, aoIr,
}: { atual: EtapaCadastro; aoIr: (etapa: EtapaCadastro) => void }) {
  return (
    <nav aria-label="Etapas do cadastro" className="flex items-start">
      {ETAPAS_CADASTRO.map((etapa, i) => {
        const ativa = etapa.id === atual
        const passada = etapaJaPassada(etapa.id, atual)
        return (
          <div key={etapa.id} className="flex items-start flex-1 last:flex-none">
            <button
              type="button"
              onClick={() => aoIr(etapa.id)}
              aria-current={ativa ? 'step' : undefined}
              className="flex flex-col items-center gap-1 w-16 shrink-0"
            >
              <span
                className={`relative w-10 h-10 rounded-full flex items-center justify-center ${
                  ativa ? 'bg-teal-700 text-white' : passada ? 'bg-teal-100 text-teal-700' : 'bg-slate-100 text-slate-500'
                }`}
              >
                <Icone etapa={etapa.id} />
                {passada && (
                  <span className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-emerald-600 text-white flex items-center justify-center">
                    <svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" strokeWidth="4"
                      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10" /></svg>
                  </span>
                )}
              </span>
              <span className={`text-xs ${ativa ? 'font-bold text-teal-800' : 'text-slate-500'}`}>{etapa.rotulo}</span>
            </button>
            {i < ETAPAS_CADASTRO.length - 1 && (
              <span className={`flex-1 h-0.5 mt-5 ${passada ? 'bg-emerald-600' : 'bg-slate-200'}`} aria-hidden="true" />
            )}
          </div>
        )
      })}
    </nav>
  )
}
